import { useContext } from 'react';
import { ResponsiveContext } from 'v3/common/provider/WithReponsiveProvider';

export const useResponsive = () => {
  return useContext(ResponsiveContext);
};
